import { createInstance } from './axios.api'
import { AxiosRequestConfig } from 'axios'
import { OrderStatusRequest, OrderStatusResponse, OrderSubmitRequest, OrderSubmitResponse } from '@/types/order.types'

export const postOrder = async (request: OrderSubmitRequest): Promise<OrderSubmitResponse> => {
  const axios = createInstance(process.env.VUE_APP_ORDER_API_URL)

  const { data } = await axios.post('/submit', request)
  return data
}

export const getStatus = async (request: OrderStatusRequest): Promise<OrderStatusResponse> => {
  const axios = createInstance(process.env.VUE_APP_ORDER_API_URL)

  const { data } = await axios.get(`/status/${request.addressId}/${request.customerGuid}`, { retry: 3, retryDelay: 3000 } as AxiosRequestConfig)
  return data
}
